/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ThoughtspotSchedule } from './ThoughtspotSchedule';
import {
    ThoughtspotScheduleFromJSON,
    ThoughtspotScheduleFromJSONTyped,
    ThoughtspotScheduleToJSON,
    ThoughtspotScheduleToJSONTyped,
} from './ThoughtspotSchedule';

/**
 * 
 * @export
 * @interface GetThoughtspotSchedulesResponse
 */
export interface GetThoughtspotSchedulesResponse {
    /**
     * 
     * @type {Array<ThoughtspotSchedule>}
     * @memberof GetThoughtspotSchedulesResponse
     */
    data: Array<ThoughtspotSchedule>;
}

/**
 * Check if a given object implements the GetThoughtspotSchedulesResponse interface.
 */
export function instanceOfGetThoughtspotSchedulesResponse(value: object): value is GetThoughtspotSchedulesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function GetThoughtspotSchedulesResponseFromJSON(json: any): GetThoughtspotSchedulesResponse {
    return GetThoughtspotSchedulesResponseFromJSONTyped(json, false);
}

export function GetThoughtspotSchedulesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetThoughtspotSchedulesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ThoughtspotScheduleFromJSON)),
    };
}

export function GetThoughtspotSchedulesResponseToJSON(json: any): GetThoughtspotSchedulesResponse {
    return GetThoughtspotSchedulesResponseToJSONTyped(json, false);
}

export function GetThoughtspotSchedulesResponseToJSONTyped(value?: GetThoughtspotSchedulesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ThoughtspotScheduleToJSON)),
    };
}

